import { render, staticRenderFns } from "./StatusIndicatorIcon.vue?vue&type=template&id=e8994afa&scoped=true"
import script from "./StatusIndicatorIcon.vue?vue&type=script&lang=js"
export * from "./StatusIndicatorIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8994afa",
  null
  
)

export default component.exports